// Country data with dialing codes
export const COUNTRY_DATA = {
  af: { name: 'Afghanistan', code: '93' },
  al: { name: 'Albania', code: '355' },
  dz: { name: 'Algeria', code: '213' },
  ad: { name: 'Andorra', code: '376' },
  ao: { name: 'Angola', code: '244' },
  ar: { name: 'Argentina', code: '54' },
  am: { name: 'Armenia', code: '374' },
  au: { name: 'Australia', code: '61' },
  at: { name: 'Austria', code: '43' },
  az: { name: 'Azerbaijan', code: '994' },
  bh: { name: 'Bahrain', code: '973' },
  bd: { name: 'Bangladesh', code: '880' },
  by: { name: 'Belarus', code: '375' },
  be: { name: 'Belgium', code: '32' },
  ba: { name: 'Bosnia and Herzegovina', code: '387' },
  br: { name: 'Brazil', code: '55' },
  bg: { name: 'Bulgaria', code: '359' },
  kh: { name: 'Cambodia', code: '855' },
  ca: { name: 'Canada', code: '1' },
  cl: { name: 'Chile', code: '56' },
  cn: { name: 'China', code: '86' },
  co: { name: 'Colombia', code: '57' },
  hr: { name: 'Croatia', code: '385' },
  cy: { name: 'Cyprus', code: '357' },
  cz: { name: 'Czech Republic', code: '420' },
  dk: { name: 'Denmark', code: '45' },
  ec: { name: 'Ecuador', code: '593' },
  eg: { name: 'Egypt', code: '20' },
  ee: { name: 'Estonia', code: '372' },
  fi: { name: 'Finland', code: '358' },
  fr: { name: 'France', code: '33' },
  ge: { name: 'Georgia', code: '995' },
  de: { name: 'Germany', code: '49' },
  gr: { name: 'Greece', code: '30' },
  hk: { name: 'Hong Kong', code: '852' },
  hu: { name: 'Hungary', code: '36' },
  is: { name: 'Iceland', code: '354' },
  in: { name: 'India', code: '91' },
  id: { name: 'Indonesia', code: '62' },
  ir: { name: 'Iran', code: '98' },
  iq: { name: 'Iraq', code: '964' },
  ie: { name: 'Ireland', code: '353' },
  il: { name: 'Israel', code: '972' },
  it: { name: 'Italy', code: '39' },
  jp: { name: 'Japan', code: '81' },
  jo: { name: 'Jordan', code: '962' },
  kz: { name: 'Kazakhstan', code: '7' },
  ke: { name: 'Kenya', code: '254' },
  kr: { name: 'Korea, South', code: '82' },
  kw: { name: 'Kuwait', code: '965' },
  lv: { name: 'Latvia', code: '371' },
  lb: { name: 'Lebanon', code: '961' },
  ly: { name: 'Libya', code: '218' },
  li: { name: 'Liechtenstein', code: '423' },
  lt: { name: 'Lithuania', code: '370' },
  lu: { name: 'Luxembourg', code: '352' },
  mk: { name: 'North Macedonia', code: '389' },
  my: { name: 'Malaysia', code: '60' },
  mt: { name: 'Malta', code: '356' },
  mx: { name: 'Mexico', code: '52' },
  md: { name: 'Moldova', code: '373' },
  mc: { name: 'Monaco', code: '377' },
  me: { name: 'Montenegro', code: '382' },
  ma: { name: 'Morocco', code: '212' },
  nl: { name: 'Netherlands', code: '31' },
  nz: { name: 'New Zealand', code: '64' },
  ng: { name: 'Nigeria', code: '234' },
  no: { name: 'Norway', code: '47' },
  om: { name: 'Oman', code: '968' },
  pk: { name: 'Pakistan', code: '92' },
  pa: { name: 'Panama', code: '507' },
  pe: { name: 'Peru', code: '51' },
  ph: { name: 'Philippines', code: '63' },
  pl: { name: 'Poland', code: '48' },
  pt: { name: 'Portugal', code: '351' },
  qa: { name: 'Qatar', code: '974' },
  ro: { name: 'Romania', code: '40' },
  ru: { name: 'Russia', code: '7' },
  sa: { name: 'Saudi Arabia', code: '966' },
  rs: { name: 'Serbia', code: '381' },
  sg: { name: 'Singapore', code: '65' },
  sk: { name: 'Slovakia', code: '421' },
  si: { name: 'Slovenia', code: '386' },
  za: { name: 'South Africa', code: '27' },
  es: { name: 'Spain', code: '34' },
  lk: { name: 'Sri Lanka', code: '94' },
  se: { name: 'Sweden', code: '46' },
  ch: { name: 'Switzerland', code: '41' },
  sy: { name: 'Syria', code: '963' },
  tw: { name: 'Taiwan', code: '886' },
  th: { name: 'Thailand', code: '66' },
  tn: { name: 'Tunisia', code: '216' },
  tr: { name: 'Turkey', code: '90' },
  ua: { name: 'Ukraine', code: '380' },
  ae: { name: 'United Arab Emirates', code: '971' },
  gb: { name: 'United Kingdom', code: '44' },
  us: { name: 'United States', code: '1' },
  uy: { name: 'Uruguay', code: '598' },
  uz: { name: 'Uzbekistan', code: '998' },
  ve: { name: 'Venezuela', code: '58' },
  vn: { name: 'Vietnam', code: '84' },
  ye: { name: 'Yemen', code: '967' },
  zm: { name: 'Zambia', code: '260' },
  zw: { name: 'Zimbabwe', code: '263' }
}; 